module.exports = __webpack_public_path__ + "img/persona-banner1.a2b6bdb2.webp";